import type { OnSelectionChangeFunc } from '@xyflow/react';
import { useStoreApi } from '@xyflow/react';
import { produce } from 'immer';
import type { MouseEvent } from 'react';
import { useCallback } from 'react';
import { useWorkflowStore } from '../store';
import type { Edge, Node } from '../types';

export const useSelectionInteractions = () => {
  const store = useStoreApi<Node, Edge>();
  const workflowStore = useWorkflowStore();

  const handleSelectionStart = useCallback(() => {
    // fix： 多选无法取消选择
    // flow v12 取消框选时不会触发该函数
    //     const { nodes, setNodes, edges, setEdges, userSelectionRect } =
    //       store.getState();
    //
    //     if (!userSelectionRect?.width || !userSelectionRect?.height) {
    //
    //       const newNodes = produce(nodes, (draft) => {
    //         draft.forEach((node) => {
    //           if (node.data._isBundled) node.data._isBundled = false;
    //         });
    //       });
    //       setNodes(newNodes);
    //       const newEdges = produce(edges, (draft) => {
    //         draft.forEach((edge) => {
    //           if (edge.data!._isBundled) edge.data!._isBundled = false;
    //         });
    //       });
    //       setEdges(newEdges);
    //     }
  }, [store]);

  const handleSelectionCancel = useCallback(() => {
    const { nodes, setNodes, edges, setEdges } = store.getState();

    store.setState({
      userSelectionRect: null,
      userSelectionActive: false,
    });

    const newNodes = produce(nodes, (draft) => {
      draft.forEach((node) => {
        if (node.data._isBundled) node.data._isBundled = false;
      });
    });
    setNodes(newNodes);
    const newEdges = produce(edges, (draft) => {
      draft.forEach((edge) => {
        if (edge.data!._isBundled) edge.data!._isBundled = false;
      });
    });
    setEdges(newEdges);
  }, [store]);

  const handleSelectionChange = useCallback<OnSelectionChangeFunc>(
    ({ nodes: nodesInSelection, edges: edgesInSelection }) => {
      const { nodes, setNodes, edges, setEdges, userSelectionRect } =
        store.getState();
      if (!userSelectionRect?.width || !userSelectionRect?.height) {
        return handleSelectionCancel();
      }

      const newNodes = produce(nodes, (draft) => {
        draft.forEach((node) => {
          const nodeInSelection = nodesInSelection.find(
            (n) => n.id === node.id,
          );

          if (nodeInSelection) node.data._isBundled = true;
          else node.data._isBundled = false;
        });
      });
      const newEdges = produce(edges, (draft) => {
        draft.forEach((edge) => {
          const edgeInSelection = edgesInSelection.find(
            (e) => e.id === edge.id,
          );

          if (edgeInSelection) edge.data!._isBundled = true;
          else edge.data!._isBundled = false;
        });
      });
      setEdges(newEdges);
      setNodes(newNodes);
    },
    [store, handleSelectionCancel],
  );

  const handleSelectionDrag = useCallback(
    (_: MouseEvent, nodesWithDrag: Node[]) => {
      //       const { nodes, setNodes } = store.getState();
      //
      //       const newNodes = produce(nodes, (draft) => {
      //         draft.forEach((node) => {
      //           const dragNode = nodesWithDrag.find((n) => n.id === node.id);
      //
      //           if (dragNode) node.position = dragNode.position;
      //         });
      //       });
      //       setNodes(newNodes);
    },
    [store, workflowStore],
  );

  return {
    handleSelectionStart,
    handleSelectionChange,
    handleSelectionDrag,
    handleSelectionCancel,
  };
};
